import { Badge } from "@/components/ui/badge";

export const taxStatusColors: Record<string, string> = {
  submitted: "bg-sky-500/15 !text-sky-700 dark:!text-sky-400",
  "in review": "bg-amber-500/15 !text-amber-700 dark:!text-amber-400",
  approved: "bg-emerald-500/15 !text-emerald-700 dark:!text-emerald-400",
  rejected: "bg-red-500/15 !text-red-600 dark:!text-red-400",
};

export function TaxStatusBadge({
  status,
  compact = false,
}: {
  status?: string;
  compact?: boolean;
}) {
  return (
    <Badge
      variant="largeTag"
      className={`w-fit ${taxStatusColors[status ?? ""] ?? "bg-background !text-secondary"} ${compact ? "justify-center rounded-full py-0 !text-[10px] leading-none" : ""}`}
    >
      {status || "N/A"}
    </Badge>
  );
}
